import React from 'react';
import './BotAvatar.css';

export default function BotAvatar({ state = 'idle', size = 48 }) {
  const mode = ['idle', 'thinking', 'reply'].includes(state) ? state : 'idle';
  return <span className={`mc-avatar mc-avatar--${mode}`} style={{ width: size, height: size }} aria-hidden="true">
    <svg viewBox="0 0 100 100" fill="none" focusable="false">
      <circle cx="50" cy="50" r="47" fill="#e0f7f5" />
      <circle className="mc-avatar__ring" cx="50" cy="50" r="45" stroke="#0d9488" strokeWidth="2" strokeDasharray="7 9" />
      <g className="mc-avatar__body">
        <path d="M30 88v-9c0-12 9-19 20-19s20 7 20 19v9" fill="#0f766e" />
        <path d="M43 74h14m-7-7v14" stroke="white" strokeWidth="5" strokeLinecap="round" />
        <g className="mc-avatar__hand"><rect x="72" y="60" width="11" height="25" rx="5.5" fill="#14b8a6" transform="rotate(-22 72 60)" /></g>
        <path d="M50 24v-8" stroke="#0f766e" strokeWidth="4" strokeLinecap="round" />
        <circle className="mc-avatar__antenna" cx="50" cy="13" r="5" fill="#14b8a6" />
        <rect x="16" y="39" width="9" height="19" rx="4.5" fill="#0f766e" />
        <rect x="75" y="39" width="9" height="19" rx="4.5" fill="#0f766e" />
        <rect x="23" y="25" width="54" height="44" rx="17" fill="#fff" stroke="#0f766e" strokeWidth="3" />
        <rect x="30" y="34" width="40" height="25" rx="10" fill="#123e48" />
        <g className="mc-avatar__eyes" fill="#8ff4df"><rect x="37" y="42" width="6" height="9" rx="3" /><rect x="57" y="42" width="6" height="9" rx="3" /></g>
        <path d="M45 55q5 4 10 0" stroke="#8ff4df" strokeWidth="2" strokeLinecap="round" />
      </g>
    </svg>
    <span className="mc-avatar__dots"><i /><i /><i /></span>
  </span>;
}
